import {Api} from "@/repository/api";
import axios from "axios";
import store from "@/store";

/**
 * @augments IApi<Entreprise>
 * @extends IApi<Entreprise>
 * @implements IApi<Entreprise>
 */
export class EntrepriseRepository extends Api {
    constructor() {
        super("entreprises");
    }

}

export class EntrepriseAttachmentRepository extends Api {
    constructor() {
        super("entreprise_attachments");
    }

    async postFile(object, update = false) {
        let data = new FormData();
        for (const key in object) {
            if (object[key] !== null && object[key] !== undefined) {
                data.append(key, object[key]);
            }
        }
        try {
            let response = update
                ? await axios.patch(`${this.url}/${object.id}/`, data, store.getters["auth/getAuth"])
                : await axios.post(`${this.url}/`, data, store.getters["auth/getAuth"]);
            return response.data;
        } catch (e) {
            store.dispatch("annonce/annonceError", "Une erreur est survenue");
            throw e;
        }
    }
}
